<footer class="custom-footer" *ngIf="viewModel$ | async as viewModel">
  <div
    class="footer-content"
    [class.footer-content--logo-only]="!viewModel.footer.supportEmail && !viewModel.footer.locationLabel && !viewModel.footer.socialLinks.length"
  >
    <div class="footer-left" *ngIf="viewModel.footer.supportEmail || viewModel.footer.locationLabel">
      <div *ngIf="viewModel.footer.supportEmail">
        <i class="fa fa-envelope"></i>
        <a [href]="viewModel.footer.supportMailto">{{ viewModel.footer.supportEmail }}</a>
      </div>
      <div *ngIf="viewModel.footer.locationLabel">
        <i class="fa fa-map-marker"></i>
        <span>{{ viewModel.footer.locationLabel }}</span>
      </div>
    </div>
    <div class="footer-center" *ngIf="viewModel.footer.socialLinks.length">
      <a
        *ngFor="let social of viewModel.footer.socialLinks"
        [href]="social.href"
        [class]="social.providerClass"
        [attr.aria-label]="social.ariaLabel"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i [class]="social.iconClass" aria-hidden="true"></i>
      </a>
    </div>
    <div class="footer-right">
      <img
        [src]="viewModel.branding.logoUrl"
        [alt]="viewModel.branding.displayName + ' logo'"
        class="footer-logo"
      />
    </div>
  </div>
  <div class="footer-bottom">
    <a routerLink="/refund-policy" class="footer-link">Refund Policy</a>
  </div>
</footer>

